import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { ModalController, NavController, NavParams, Platform, PopoverController, ViewController } from 'ionic-angular';
import { Storage } from '@ionic/storage'
import { CajaProvider } from '../../providers/caja/caja';
import { ClientesVentasComponent } from '../clientes-ventas/clientes-ventas';
import { WhatsappPage } from '../../pages/whatsapp/whatsapp';
import { AppState } from '../../app/app.reducer';
import { Store } from '@ngrx/store';
import  'rxjs/add/observable/interval';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/map';
import { CompaniasProvider } from '../../providers/companias/companias'
import {  NUBE_AWS } from "../../config/url.servicio"
import { PushProvider } from '../../providers/push/push'
import { ImpresoraBluePage } from '../../pages/impresora-blue/impresora-blue'
import { UtilsProvider } from '../../providers/utils/utils'
import { saveAs } from 'file-saver';
import { DianProvider } from '../../providers/dian/dian';
import { ImprimirGlobalComponent } from '../../pages/imprimir-global/imprimir-global';

@Component({
  selector: 'factura-select',
  templateUrl: 'factura-select.html',
  providers: [DianProvider]
})
export class FacturaSelectComponent {
  data:any[] = []
  paginaActual: number = 1;
  buscarTexto: string = '';
  item: string = '';
  ventasDiarias = []
  cantidadImpresionesEnCaja: string = "1"
  tags = ['Ionic', 'Angular', 'TypeScript'];

  listaGruposProductos = []
  valoresCliente: string = 'Buscar Cliente';
  listaProductos = []
  listaClientes = [];
  filtrogruposProductosId
  // filtroABC
  // loader variable para guardar dialogos de alertas
  loader
  // saber si se esta filtrando
  nombreFiltroGrupo
  filtroGruposActivo: boolean = false
  // lista de productos que se van a comprar
  listaProductosSeleccionados = []
  valorTotalVenta = 0
  valorTotalProductos = 0
  valorTotalImpuestos = 0
  price = 0
  valorTotalDevolver = 0
  // saber si se esta realizando una venta
  realizandoUnaVenta: boolean = false
  clienteId = []
  clienteGenerico

  listaMuestra = []
  valormesa = 0
  datosAdicionales
  listaDenominaciones = []
  nombreCompaniaHeader:any=""
  nombreCargoHeader:any=""
  timerVar;
  timerCodigoBarra;
  timerVal;
  public picture;
  public codigoBarra:any =""
  cantidadRealCodigoBarra:number = 0
  public formState: string = 'collapsed'
  public formStateDescripcion: string = 'collapsed'
  public formStatebool:boolean= false
  public formStateboolDescripcion:boolean= false
  codigoProducto
  nombreProducto
  valorVenta
  valorImpuesto:number=0
  costo:number=0
  gruposProductosId
  productoId
  listaGrupos
  CheckCredito:boolean = false
  CheckImprimir:boolean = false
  datosCredito = []

  valorImpuestosIndividual:number=0
  valorProductoIndividual :number=0
  allItems: any;
  manejaImpresoPorDefecto:boolean = true
  bluetooth:boolean = false
  listaABC = []
  imagenImprimir:boolean = false
  token:string
  element: HTMLElement;
  blue:string=''
  CheckPorcentajeServicio:boolean = false
  valorTotalServicio:number=0
  porcentajeServicioValor:string="N"
  porcentajeServicioValorPedidosSalon:string="N"
  cambiarFecha:boolean = false
  manejaCajaDinamica:boolean = false
  digitaCantidadEnVenta: boolean = false
  devolverVenta: boolean = false
  creaProductoRapidoDesdeCaja: boolean = false
  manejaCodigoDeBarras: boolean = false

  digitaDescripcion: boolean = false
  descripcionVenta: string = ""
  creaClienteDesdeCaja: boolean = false
  estadoFormCrearCliente: boolean = false
  visualizaDetalleReciboEnCaja: boolean = false
  formaPagoSeleccionada: string = 'O'

  telefonoClienteRapido: string = ""
  nombreClienteRapido: string = ""
  direccionClienteRapido: string = ""
  cambiarPrecioEnLosProductos: boolean = false
  refactorizarPedidosSalon: boolean = false
  companiasId
  fechaVencimiento:Date
  manejaPlanDePagosEnCuentasPorCobrar: boolean = false
  guardarPlanDePagosEnCuentasPorCobrarSimulador: boolean = false
  gestionarSimuladorCuotasExtras: any | string = ''
  usuariosId
  nombreUsuario
  poselectronico: boolean= false;
  isLoading=false;
  datosIniciales= [{fechaInicial: this.devolverFechaVentasDiarias(),
    fechaFinal: this.devolverFechaVentasDiarias(),
    deDonde:'C'
  }]
  constructor(public navCtrl: NavController, public navParams: NavParams,
              public viewControllers:ViewController,
              public storage: Storage,
              public servicio: CajaProvider,
              public modalControllers: ModalController,
              private storePedidosSalon: Store<AppState>,
              public servicioCompania:CompaniasProvider,
              public platforms: Platform,
              public push:PushProvider,
              public utils:UtilsProvider,
              public dian: DianProvider,
              private popoverCtrl: PopoverController,) {
                this.servicioCompania.devolverVarios(['nombreCompania','nombreCargo','companiasId'])
                .then(async (val)=>{

                  if(val){
                    this.nombreCompaniaHeader = val['nombreCompania']
                    this.nombreCargoHeader = val['nombreCargo']
                    this.companiasId = val['companiasId']
                    this.buscarClientes(this.companiasId);

                    this.push.buscarParametrosGenerales(this.companiasId).subscribe((data)=>{
                      if(NUBE_AWS) {
                        let valuesData = JSON.parse(data['_body']).data[0][0]
                        this.bluetooth = valuesData.bluetooth === 'B' ? true : false
                        this.manejaImpresoPorDefecto = valuesData.manejaImpresoPorDefecto == 0 ? false : true
                        this.imagenImprimir = valuesData.imagen
                        this.manejaCajaDinamica = valuesData.manejaCajaDinamica === 'N' ? false : true;
                        this.digitaCantidadEnVenta = valuesData.digitaCantidadEnVenta === 'N' ? false : true;
                        this.devolverVenta = valuesData.devolverVenta === 'N' ? false : true;
                        this.creaProductoRapidoDesdeCaja = valuesData.creaProductoRapidoDesdeCaja === 'N' ? false : true;
                        this.manejaCodigoDeBarras = valuesData.manejaCodigoDeBarras === 'N' ? false : true;
                        this.CheckImprimir = valuesData.activoImprimir === 'N' ? false : true;
                        this.cantidadImpresionesEnCaja = valuesData.cantidadImpresonesCaja.toString();
                        this.digitaDescripcion = valuesData.digitaDescripcionEnCaja === 'N' ? false : true;
                        this.creaClienteDesdeCaja = valuesData.creaClienteDesdeCaja === 'N' ? false : true;
                        this.visualizaDetalleReciboEnCaja = valuesData.visualizaDetalleReciboEnCaja === 'N' ? false : true;
                        this.manejaPlanDePagosEnCuentasPorCobrar = valuesData.manejaPlanDePagosEnCuentasPorCobrar === 'N' ? false : true;
                        this.cambiarPrecioEnLosProductos = valuesData.cambiarPrecioEnLosProductos === 'N' ? false : true;
                        this.cambiarPrecioEnLosProductos = valuesData.cambiarPrecioEnLosProductos === 'N' ? false : true;
                      } else {
                        this.bluetooth = data[0][0].bluetooth === 'B' ? true : false
                        this.manejaImpresoPorDefecto = data[0][0].manejaImpresoPorDefecto == 0 ? false : true
                        this.imagenImprimir = data[0][0].imagen
                        this.manejaCajaDinamica = data[0][0].manejaCajaDinamica === 'N' ? false : true;
                        this.digitaCantidadEnVenta = data[0][0].digitaCantidadEnVenta === 'N' ? false : true;
                        this.devolverVenta = data[0][0].devolverVenta === 'N' ? false : true;
                        this.creaProductoRapidoDesdeCaja = data[0][0].creaProductoRapidoDesdeCaja === 'N' ? false : true;
                        this.manejaCodigoDeBarras = data[0][0].manejaCodigoDeBarras === 'N' ? false : true;
                        this.CheckImprimir = data[0][0].activoImprimir === 'N' ? false : true;
                        this.cantidadImpresionesEnCaja = data[0][0].cantidadImpresonesCaja.toString();
                        this.digitaDescripcion = data[0][0].digitaDescripcionEnCaja === 'N' ? false : true;
                        this.creaClienteDesdeCaja = data[0][0].creaClienteDesdeCaja === 'N' ? false : true;
                        this.visualizaDetalleReciboEnCaja = data[0][0].visualizaDetalleReciboEnCaja === 'N' ? false : true;
                      }


                      if(this.manejaImpresoPorDefecto){
                          if(this.bluetooth){
                              this.manejaImpresoPorDefecto = false
                          }
                      }
                  },(error)=>{
                      console.log(error)
                  })

                  }
                })
  }



  ionViewDidLoad() {
    const element = document.getElementsByClassName('modal-wrapper')[0] as HTMLElement;
    element.style.height = '100%';
    element.style.width = '100%';
    element.style.top = '0';
    element.style.left = '0';
    element.style.right = '0';
    element.style.bottom = '0';
    this.paginaActual = 1;
    this.storage.get('companiasId').then((val) => {
      this.servicio.buscarVentasdiariasCajaPrincipal(val,1)
      .subscribe((data) => {
        this.ventasDiarias = JSON.parse(data['_body']).data[0] === undefined ? [] : JSON.parse(data['_body']).data
      }, (error) => {
        console.log(error);
      });
    });
  }

  dismiss(){
    this.viewControllers.dismiss();
  }

  submit(){
   this.viewControllers.dismiss(this.item);
  }

  buscar(event) {
    this.buscarTexto = event.value;
  }
  devolverValor(item) {
    this.item = item;
    this.submit();
  }
  actualizarCliente(item: any) {
    console.log('actualizar cliente' + item.toString())
    let modal = this.modalControllers.create(ClientesVentasComponent, {
      item: item
      }
      )
    modal.present();

    modal.onDidDismiss(data => {
      if (data) {
        console.log('data', data)


      }
    })
  }
  async abrirWhatsApp(item){
    this.storage.get('companiasId').then((companiasId)=>{
      this.servicio.imprimirComandaBlue(item.factura,companiasId)

     .subscribe(async (data)=>{



     let items = JSON.parse(data['_body']).data
     if(items){
      let dataImprimir = JSON.stringify(items[0])
      let clienteCaja = await this.buscarClienteStore();
      let numeroTelefono = ''

      if(clienteCaja['valuedisplay'] !== undefined && clienteCaja['valuedisplay'][0] !== undefined && clienteCaja['valuedisplay'][0].value !== undefined){
        let displaSplit = clienteCaja['valuedisplay'][0].display.split('-')
        numeroTelefono = displaSplit[1]
        numeroTelefono = numeroTelefono.trim()
      }

      let modal = this.modalControllers.create(WhatsappPage, { dataImprimir: dataImprimir, numeroTelefono: numeroTelefono, espacios: false }
        )
      modal.present();

      modal.onDidDismiss(data => {
        if (data) {
        }
      })
    }
     })
 })
  }
  async buscarClienteStore() {
    return new Promise((resolve, reject) => {
       this.storePedidosSalon.select('clienteSelect').subscribe((clientecaja) => {
         return resolve(clientecaja)
       })
     });
   }
   imprimirFacturadia(codigo:any){
    if(this.platforms.is('android') || this.platforms.is('ios')){
      this.printD(codigo,true,true)
    }else{

      this.storage.get('companiasId').then((val) => {
        let factura:number
        factura = Number(codigo.factura)

        this.servicio.buscarVentasDiarias(factura,val)
        .subscribe((data)=>{
          let response = NUBE_AWS ? JSON.parse(data['_body']).data[0] : data
          if(this.cantidadImpresionesEnCaja == undefined) {
            this.cantidadImpresionesEnCaja = "1"
            console.log('validar this.cantidadImpresionesEnCaja')
          }
          for(var i = 1; i <= parseInt(this.cantidadImpresionesEnCaja,10); i++){
            this.reemprimirReciboDia(response)
          }

        },
        error=>{
          console.log(error)
        })
      })
    }
}

imprimirFacturadiaTendero(codigo:any){
  if(this.platforms.is('android') || this.platforms.is('ios')){
    this.printD(codigo,true,true)
  }else{

    this.storage.get('companiasId').then((val) => {
      let factura:number
      factura = Number(codigo.factura)

      this.servicio.buscarVentasDiariasTendero(factura,val)
      .subscribe((data)=>{
        let response = NUBE_AWS ? JSON.parse(data['_body']).data[0] : data
        if(this.cantidadImpresionesEnCaja == undefined) {
          this.cantidadImpresionesEnCaja = "1"
          console.log('validar this.cantidadImpresionesEnCaja')
        }
        for(var i = 1; i <= parseInt(this.cantidadImpresionesEnCaja,10); i++){
          this.reemprimirReciboDia(response)
        }

      },
      error=>{
        console.log(error)
      })
    })
  }
}

buscarClientes(companiasId) {
  this.servicio.buscarClientesPorCompaniaAll(companiasId)
  .subscribe((data: any)=>{
    let clientes: any = data;
    this.listaClientes = clientes;
  })
}
reemprimirReciboDia(mensaje) {
  let recibo = ''

// for (let index:any = 0; index < mensaje.length; index++) {
//   recibo +=  '   ' + mensaje[index]['reciboCaja'] + '\n'
// }
for (let index:any = 0; index < mensaje.length; index++) {
  //recibo +=  '   ' + mensaje[index]['reciboCaja'] + '\n'
  const textoRecibo = mensaje[index]['reciboCaja'];

  // Comandos ESC/POS para negrita y tamaño de fuente
  const negritaOn = '\x1b\x45\x01'; // Activar negrita
  const negritaOff = '\x1b\x45\x00'; // Desactivar negrita
  const tamañoGrandeNotanto = '\x1b\x21\x10'; // Cambiar a tamaño de fuente grande
  const tamañoGrande = '\x1b\x21\x20'; // Cambiar a tamaño de fuente grande
  const tamañoNormal = '\x1b\x21\x00'; // Cambiar a tamaño de fuente normal

  if (textoRecibo.includes("TOTAL A PAGAR")) {
    recibo += negritaOn + tamañoGrande + '   ' + textoRecibo + '\n' + tamañoNormal + negritaOff;
  } else {
    if(textoRecibo.includes("CAMBIO")) {
      recibo += negritaOn + tamañoGrandeNotanto + '   ' + textoRecibo + '\n' + tamañoNormal + negritaOff;
    } else {
      recibo += '   ' + textoRecibo + '\n';
    }
  }
}

  this.servicio.imprimirRecibo(recibo).subscribe(
      res => {

      },
      err => {
        this.utils.mostrarReciboDeCajaEnPantalla('',mensaje)

          })
}

async reemprimirReciboDiaCufe(mensaje,cufe:any='') {
  let recibo = ''

for (let index:any = 0; index < mensaje.length; index++) {
  //recibo +=  '   ' + mensaje[index]['reciboCaja'] + '\n'
  const textoRecibo = mensaje[index]['reciboCaja'];

  // Comandos ESC/POS para negrita y tamaño de fuente
  const negritaOn = '\x1b\x45\x01'; // Activar negrita
  const negritaOff = '\x1b\x45\x00'; // Desactivar negrita
  const tamañoGrandeNotanto = '\x1b\x21\x10'; // Cambiar a tamaño de fuente grande
  const tamañoGrande = '\x1b\x21\x20'; // Cambiar a tamaño de fuente grande
  const tamañoNormal = '\x1b\x21\x00'; // Cambiar a tamaño de fuente normal

  if (textoRecibo !== null && textoRecibo.includes("TOTAL A PAGAR")) {
    recibo += negritaOn + tamañoGrande + '   ' + textoRecibo + '\n' + tamañoNormal + negritaOff;
  } else {
    if(textoRecibo !== null && textoRecibo.includes("CAMBIO")) {
      recibo += negritaOn + tamañoGrandeNotanto + '   ' + textoRecibo + '\n' + tamañoNormal + negritaOff;
    } else {
      recibo += '   ' + textoRecibo + '\n';
    }
  }
}

this.servicio.imprimirReciboCufe(recibo,cufe).subscribe(
  res => {

  },
  err => {
    this.utils.mostrarReciboDeCajaEnPantalla('',mensaje)

      })

}






printD(item:any,imagenes:boolean,canvas:boolean): void {

  let codigo = 0
  let queImprimo = 0

  codigo =  item.codigo
  if(codigo===undefined){
  codigo =  item.factura
  queImprimo = 1
  }


  this.storage.get('companiasId').then((companiasId)=>{
       this.servicio.imprimirComandaBlue(codigo,companiasId)

      .subscribe((data)=>{



      let items = JSON.parse(data['_body']).data
      this.modalPrintCualquieraBlutooth(items)
      })
  })

}

modalPrintCualquieraBlutooth(item:any){

  this.guardarBlutooth(item)
}

guardarBlutooth(item: any) {
const datos = {
  "nombre": JSON.stringify(item)
  }
this.descargarArchivo(datos)
}
descargarArchivo(data:any){

  let item = data

 let modal = this.modalControllers.create(ImpresoraBluePage,{item})
  modal.present();

  modal.onDidDismiss(data => {
      this.limpiarImpresion()
    if (data) {
      data.name = ""
      }
  })

}

limpiarImpresion(){
  return
}

devolverFactura(codigo:any){

  this.storage.get('companiasId').then((val) => {
       let factura:number
       factura = Number(codigo.factura)

       this.utils.mensajeConfirmacionDos('Factura','¿Está Seguro de devolver la factura ?','question','Si','No')
  .then((eliminarFactura: boolean) => {
   if (eliminarFactura) {

     this.servicio.devolverVenta(val,factura)
     .subscribe((data)=>{
       this.utils.mensajeMuestro(`Factura`,'Devuelta Exitosamente!','success')
       this.buscarVentasdiariasCaja()
     },
      error=>{
        console.log(error)
      })


   }
   else {
     this.utils.mensajeMuestro('Factura','No se eliminó la factura','warning')
   }
 })

   })
}

buscarVentasdiariasCaja(){
  this.storage.get('companiasId').then((val) => {

        this.servicio.buscarVentasdiariasCajaPrincipal(val,1)
        .subscribe((data)=>{
          if(NUBE_AWS){
            this.ventasDiarias = JSON.parse(data['_body']).data[0] === undefined ? [] : JSON.parse(data['_body']).data
          } else {
            this.ventasDiarias = JSON.parse(data['_body'])
          }
        },(error)=>{
            console.log(error)
        })

    });
}

async visualizarDetalleVenta(reciboCaja: any){
  let textoHtmlReciboCaja = reciboCaja.factura

  this.storage.get('companiasId').then(async (val) => {
    let factura:number
    factura = Number(textoHtmlReciboCaja)

    let cufeResponse = await this.dian.buscarCufe(val,reciboCaja.factura).toPromise()
    let cufeNuevo = JSON.parse(cufeResponse['_body'])
    let codigoQr = undefined
    if(cufeNuevo && cufeNuevo.data && cufeNuevo.data[0] && cufeNuevo.data[0][0]) {
      codigoQr = cufeNuevo.data[0] && cufeNuevo.data[0][0].cufe
    }
    this.servicio.buscarVentasDiarias(factura,val)
    .subscribe(async (elReciboDeCaja)=>{
      this.utils.mostrarReciboDeCajaEnPantalla(textoHtmlReciboCaja, elReciboDeCaja,codigoQr)
    },
    error=>{
      console.log(error)
    })
  })
}
devolverFechaVentasDiarias(): string{
  var f = new Date();
  let fechaSinFormato = f.getFullYear() + "-" + (f.getMonth() +1) + "-" + f.getDate()

  let fecha = this.formatearCadena(fechaSinFormato)
  return fecha

 }

devolverFechaCiere(): string{
  var f = new Date();
  // let fechaSinFormato = f.getFullYear() + "-" + f.getDate() + "-" + (f.getMonth() +1)
  let fechaSinFormato = f.getFullYear() + "-" +  (f.getMonth() +1) +  "-" + f.getDate()

  let fecha = this.formatearCadena(fechaSinFormato)
  return fecha

 }

 formatearCadena(cadena){
  let valorinicial = cadena.length
  let primero,segundo,ultimo
  primero = cadena.substr(0,4)
  segundo = cadena.substr(5,2)
  ultimo = cadena.substr(valorinicial - 2, valorinicial)
  if(valorinicial != 10){
    let recorrer = cadena.split('-')
    for(var i = 0; i < recorrer.length;i++) {
      if(i == 1 && recorrer[i].length == 1) {
        segundo = `0${recorrer[i]}`
      }
      if(i == 2 && recorrer[i].length == 1){
        ultimo = `0${recorrer[i]}`
      }
    }
  }
  return `${primero}-${segundo}-${ultimo}`
}
async generarPDFFactura(item: any) {
  this.dian.devolverPdfFacturaElectronica(item.prefijo).subscribe((item)=>{
    const byteCharacters = atob(item.B64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });

    // Crear una URL local para el blob
    const blobURL = URL.createObjectURL(blob);
    let nombreArchivo = item.NomreArchivo != undefined ? item.NomreArchivo  : 'archivo.pdf'
    // Descargar el archivo usando FileSaver.js
    console.log('blobURL', blobURL)
    saveAs(blobURL, nombreArchivo);

    // Liberar la URL del blob
    URL.revokeObjectURL(blobURL);


  },(err)=>{
    console.log('error', err)
  })
}

ngOnChanges(changes: SimpleChanges) {
  if (changes.origenFacturaSelect) {
    console.log('Origen Factura Select:', changes.origenFacturaSelect.currentValue);
  }
}

async valoresCufe(item:any = undefined) {
  //let codigoQr = "1cca40bc973ea81305e40b75427782bc6aa8d3a6c0e9ede7471e55665e48600cad58619ea89f214448317590ecbfc834"
  let codigoQr = ''
   let responseCompania = await this.dian.devolverCompania()
    let companiaId = this.companiasId == undefined ? responseCompania : this.companiasId

    let cufeResponse = await this.dian.buscarCufe(companiaId,item.factura).toPromise()
    let cufeNuevo = JSON.parse(cufeResponse['_body'])
    if(companiaId == '2') {
      codigoQr ='1b9dd52bc8b816ef8b25d4e984661420dbd5393e0b16fe021b0555db2830983d0d4917cf762fe4aa7ac6bbdd5d8681e7'
      this.imprimirFacturadiaCufe(item,codigoQr)
      return
    }
    if(cufeNuevo && cufeNuevo.data && cufeNuevo.data[0] && cufeNuevo.data[0][0]) {
      codigoQr = cufeNuevo.data[0] && cufeNuevo.data[0][0].cufe
      this.imprimirFacturadiaCufe(item,codigoQr)
    }
}

async imprimirGlobal(text:any,cufe:string) {
  let ipAddress = await localStorage.getItem('ipAddress')
  let data = {
    factura:text
  }
        let popover = this.popoverCtrl.create(ImprimirGlobalComponent, { text: data,
          queHago:'imprimirFacturadia',
          cantidadImpresionesEnCaja: 1,
          ip:ipAddress,
          cufe:cufe
        });
        popover.present({
          ev: text
        });

        popover.onDidDismiss((data) => {
          if (data) {

            console.log(data);
          }
        });
      }


      imprimirFacturadiaCufe(codigo:any,cufe:any=''){
          this.storage.get('companiasId').then((val) => {
            let factura:number
            factura = Number(codigo.factura)

            this.servicio.buscarVentasDiariasCufe(factura,val)
            .subscribe((data)=>{
              let response = NUBE_AWS ? JSON.parse(data['_body']).data[0] : data
              if(this.cantidadImpresionesEnCaja == undefined) {
                this.cantidadImpresionesEnCaja = "1"
                console.log('validar this.cantidadImpresionesEnCaja')
              }
              for(var i = 1; i <= parseInt(this.cantidadImpresionesEnCaja,10); i++){
                this.reemprimirReciboDiaCufe(response,cufe)
              }

            },
            error=>{
              console.log(error)
            })
          })
        }
}



// WEBPACK FOOTER //
// ./src/components/factura-select/factura-select.ts